module.exports = __webpack_public_path__ + "img/Sorting.04863b20.png";